import { string, number } from "prop-types";
import { useState } from "react";
import Popup from "../../../../Common/js/components/Popup/Popup.jsx";

const propTypes = {
  referenceName: string.isRequired,
  referenceText: string.isRequired,
};

const ReferenceLink = (props) => {
  const { referenceName, referenceText, top, left } = props;
  const [isHidden, setHidden] = useState(true);

  const handleClick = (event) => {
    const referenceAccordions = document.getElementsByClassName(
      "js-references-accordion",
    );
    if (referenceAccordions) {
      const references = referenceAccordions[0].getElementsByClassName(
        "js-accordion",
      )[0];
      if (!references.classList.contains("is-open")) {
        references.getElementsByClassName("js-accordion-link")[0].click();
      }
    }
  };

  return (
    <div
      className="reference-link__container"
      onMouseEnter={() => setHidden(false)}
      onMouseLeave={() => setHidden(true)}
    >
      <sup>
        <a
          className="reference"
          id={`p-ref${referenceName}`}
          href={`#ref${referenceName}`}
          onClick={handleClick}
        >
          {referenceName}
        </a>
      </sup>
      <Popup
        className="reference-link__popup"
        isHidden={isHidden}
        top={10}
        left={10}
        offset={12}
        width={350}
        triangleSide="left"
        triangleAlignment={0.15}
        flipToContain="viewport"
        nudgeToContain="viewport"
      >
        {referenceText}
      </Popup>
    </div>
  );
};

ReferenceLink.propTypes = propTypes;
export default ReferenceLink;
